import React, { useState } from 'react';
import { BlendedProductionOutput } from '../types/instrumentForge.types';
import { CopyButton } from '@components/CopyButton';
import { Terminal, FileText, LayoutGrid } from 'lucide-react';

interface PhysicsPreviewProps {
  output: BlendedProductionOutput;
}

const PhysicsPreview: React.FC<PhysicsPreviewProps> = ({ output }) => {
  const [view, setView] = useState<'full' | 'tags'>('full');

  return (
    <div className="bg-slate-950 border-l-4 border-l-accent rounded-2xl overflow-hidden shadow-inner">
      <div className="bg-slate-900 px-4 py-2 border-b border-slate-800 flex items-center justify-between">
        <div className="flex gap-2">
          <button 
            onClick={() => setView('full')}
            className={`px-3 py-1.5 rounded-lg text-[11px] font-black uppercase tracking-widest transition-all ${view === 'full' ? 'bg-slate-800 text-accent' : 'text-slate-400 hover:text-slate-300'}`}
          >
            <FileText size={12} className="inline mr-1.5" /> Full Blueprint
          </button>
          <button 
            onClick={() => setView('tags')}
            className={`px-3 py-1.5 rounded-lg text-[11px] font-black uppercase tracking-widest transition-all ${view === 'tags' ? 'bg-slate-800 text-accent' : 'text-slate-400 hover:text-slate-300'}`}
          >
            <Terminal size={12} className="inline mr-1.5" /> Suno Tags
          </button>
        </div>
        <CopyButton textToCopy={view === 'full' ? output.fullPromptBlock : output.sunoTags.join(', ')} />
      </div>
      
      <div className="p-6 max-h-[300px] overflow-y-auto custom-scrollbar bg-slate-950/40">
        {view === 'full' ? (
          <pre className="text-[11px] text-slate-400 font-mono leading-relaxed whitespace-pre-wrap">{output.fullPromptBlock}</pre>
        ) : (
          <div className="flex flex-wrap gap-2">
            {output.sunoTags.map((tag, i) => (
              <span key={i} className="px-2 py-1 bg-slate-900 border border-slate-800 rounded text-[11px] text-accent font-bold uppercase">{tag}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PhysicsPreview;
